export default "__VITE_ASSET__zRwMqoWe__"